/* ------------------------------------------------------------
   Trello #1244 - LiCHt Mobel ek islevler (01.08.2026)
   05.08.2026: pazar yeri butonu + markaya ozel guven rozetleri
   05.08.2026 (2): YERLESIM DUZELTMESI - asagidaki nota bak
   28.08.2026: PAZAR YERI BUTONU BU DOSYADAN KALDIRILDI.
     Buton artik JS ile enjekte edilmiyor; tema duzenleyicideki
     "Custom liquid" blogundan (urun bilgi kolonu) geliyor ve
     ".lm-mp" sinifini tasiyor.
     Kaldirilanlar: MARKETPLACE_URL, buildMarketplace,
     mountMarketplace, run("lm-marketplace", ...) ve alttaki
     dongudeki run("market-remount", ...) satiri.
     ICONS.store DURUYOR - mountTrust hala kullaniyor.
   28.08.2026 (2): Rozetler pazar yeri KARTININ ALTINA aliniyor.
     mountBadges once ".lm-mp" kartini ariyor; bulursa rozetleri
     onun altina, bulamazsa (kart kaldirilmissa) eskisi gibi
     sepete ekle butonunun altina koyuyor.

   ONEMLI: Bu dosya theme.liquid icinde vendor.js / theme.js'DEN
   ONCE yuklenir. Sebep madde 11: temanin <predictive-search>
   bileseni tanimlanmadan once DOM'a mudahale etmek gerekiyor.

   Geri almak icin: layout/theme.liquid icindeki custom-fixes.js
   satirini silmek yeterli. Temanin kendi dosyalarina dokunulmadi.
   ------------------------------------------------------------ */
(function () {
  "use strict";

  var CFG = window.LM_FIX || {};

  function run(name, fn) {
    try { fn(); } catch (e) {
      if (window.console && console.warn) console.warn("[lm-fix] " + name, e);
    }
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function insertNear(selectors, node, position, root) {
    for (var i = 0; i < selectors.length; i++) {
      var t = $(selectors[i], root);
      if (t) { t.insertAdjacentElement(position, node); return true; }
    }
    return false;
  }

  /* ------------------------------------------------------------
     YERLESIM YARDIMCILARI (05.08.2026 - 2. tur)
     ------------------------------------------------------------
     Ilk surumde pazar yeri butonu ve rozetler sayfadaki ILK
     ".shopify-payment-button" ogesinin altina ekleniyordu. Tema
     ayni markup'i gizli sablonlarda da (mobil sticky sepet cubugu,
     hizli goruntuleme) basiyor ve o kopya DOM'da daha once
     geldigi icin eklentiler GIZLI kabin icine dusuyordu:
     kaynak kodda vardilar ama sayfada hic gorunmuyorlardi.

     Cozum: hedefi secerken (1) gercekten olculebilir bir kutusu
     olan (gorunur) ogeleri al, (2) sepet cekmecesi / sticky cubuk /
     hizli goruntuleme gibi kaplarin icindekileri ele, (3) once
     gorunur "sepete ekle" butonunu, olmazsa yedek secicileri kullan.
     ------------------------------------------------------------ */
  function isVisible(el) {
    if (!el) return false;
    return !!(
      el.offsetWidth ||
      el.offsetHeight ||
      (el.getClientRects && el.getClientRects().length)
    );
  }

  var HIDDEN_HOSTS =
    "cart-drawer, .cart-drawer, .drawer, quick-view, .quick-view, " +
    ".mobile-sticky-bar, [class*='sticky-atc'], [class*='mobile-sticky'], template";

  function inHiddenHost(el) {
    return !!(el && el.closest && el.closest(HIDDEN_HOSTS));
  }

  function findProductAnchor() {
    var root = $("#MainContent") || document.body;

    // 1) Gercekten gorunen "In den Warenkorb" butonu
    var addButtons = $$('[name="add"]', root);
    for (var i = 0; i < addButtons.length; i++) {
      var b = addButtons[i];
      if (!isVisible(b) || inHiddenHost(b)) continue;
      return (b.closest && b.closest(".product-form__buttons")) || b.parentNode;
    }

    // 2) Yedek: gorunur form kaplari
    var sels = [".product-form__buttons", ".shopify-payment-button", 'form[action*="/cart/add"]'];
    for (var s = 0; s < sels.length; s++) {
      var list = $$(sels[s], root);
      for (var j = 0; j < list.length; j++) {
        if (isVisible(list[j]) && !inHiddenHost(list[j])) return list[j];
      }
    }
    return null;
  }

  /* ============================================================
     MADDE 11 - Arama paneli hic acilmiyordu
     ------------------------------------------------------------
     Temanin PredictiveSearch bileseni constructor'in en basinda
       this.resetButton.addEventListener("click", ...)
     cagiriyor. resetButton = querySelector('button[type="reset"]').
     Tema bu butonu markup'a basmadigi icin deger null oluyor ve
     TypeError firlatiliyor; constructor yarida kesildigi icin
     input dinleyicisi, searchContent ve states hic kurulmuyor.
     ============================================================ */
  run("search-reset-shim", function () {
    $$("predictive-search").forEach(function (ps) {
      if (ps.querySelector('button[type="reset"]')) return;
      var field = ps.querySelector(".search__field") || ps.querySelector("form");
      if (!field) return;
      var btn = document.createElement("button");
      btn.type = "reset";
      btn.className = "btn--inherit search__field-icon absolute lm-search-reset";
      btn.setAttribute("aria-label", "Suche zurücksetzen");
      btn.innerHTML =
        '<svg viewBox="0 0 20 20" width="15" height="15" fill="none" aria-hidden="true">' +
        '<path d="M15 5 5 15M5 5l10 10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
      field.appendChild(btn);
    });
  });

  /* ============================================================
     MADDE 1 - Guven / guvenli odeme rozetleri (metin seridi)
     ------------------------------------------------------------
     Urun sayfasinda bu metin seridi yerine markanin kendi
     dairesel rozetleri gosteriliyor (asagidaki LM_BADGES).
     Footer / yan sepet / sepet sayfasinda metin seridi kaldi.
     ============================================================ */
  var ICONS = {
    lock: '<path d="M5.5 9V6.5a3.5 3.5 0 1 1 7 0V9M4.5 9h9a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1Z"/>',
    card: '<path d="M2.5 5.5h13a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1ZM1.5 8.5h15M4 12h3"/>',
    truck: '<path d="M1.5 4.5h9v8h-9v-8ZM10.5 7.5h3l2.5 2.5v2.5h-5.5v-5ZM5 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM13 15a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"/>',
    store: '<path d="M2.5 7.5h13v8h-13v-8ZM1.5 7.5 3 2.5h12l1.5 5M7 15.5v-4h4v4"/>'
  };

  function trustItem(icon, title, text) {
    return (
      '<li class="lm-trust__item">' +
      '<span class="lm-trust__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.3" ' +
      'stroke-linecap="round" stroke-linejoin="round">' + ICONS[icon] + "</svg></span>" +
      '<span class="lm-trust__copy"><strong>' + title + "</strong><em>" + text + "</em></span>" +
      "</li>"
    );
  }

  function buildTrust(variant) {
    var el = document.createElement("div");
    el.className = "lm-trust lm-trust--" + variant;
    var items = [
      trustItem("lock", "SSL-verschlüsselt", "Sichere, verschlüsselte Verbindung"),
      trustItem("card", "Sichere Zahlung", "Geprüfte Zahlungsanbieter"),
      trustItem("truck", "Gratis Versand", "ab " + (CFG.freeShipping || "CHF 1'500")),
      trustItem("store", "Lokale Filialen", "Kriens & Ebikon")
    ];
    if (variant === "compact") items = items.slice(0, 3);
    el.innerHTML = '<ul class="lm-trust__list">' + items.join("") + "</ul>";
    return el;
  }

  function mountTrust() {
    var drawer = $("cart-drawer") || $(".cart-drawer");
    if (drawer && !$(".lm-trust--drawer", drawer)) {
      insertNear([".drawer__footer"], buildTrust("drawer"), "afterbegin", drawer);
    }
    if (CFG.page === "cart" && !$(".lm-trust--cart")) {
      insertNear(
        ['[name="checkout"]', ".cart__footer", ".cart__blocks"],
        buildTrust("cart"),
        "afterend"
      );
    }
  }
  run("trust-badges", mountTrust);

  /* ============================================================
     05.08.2026 - Markaya ozel dairesel guven rozetleri
     ------------------------------------------------------------
     Musteriden gelen 4 rozet magaza dosyalarina yuklendi
     (400x400 JPG, ~48 KB). Metin gorselin icine gomulu oldugu
     icin her rozete aciklayici alt metni ayrica yaziliyor.
     Shopify CDN &width= parametresiyle olceklendigi icin
     srcset ile cihaza uygun boyut iniyor; loading=lazy ve
     sabit width/height ile yer kaymasi (CLS) olmuyor.

     Yerlesim:
       - anasayfa: ilk bolumun (hero) hemen altinda serit
       - urun sayfasi: pazar yeri kartinin (.lm-mp) altinda.
         Kart bir tema blogu oldugu icin formdan SONRA render
         ediliyor; rozetleri onun altina almak istiyorsak hedefi
         kartin blok kabi (.product__block) olarak secmeliyiz.
         Kart yoksa yedek olarak sepete ekle butonu kullanilir.
     ============================================================ */
  var BADGE_BASE = "https://cdn.shopify.com/s/files/1/0797/3204/8218/files/";
  var LM_BADGES = [
    { file: "lm-badge-versichert.jpg?v=1785940537",
      alt: "Sicher verpackt & versichert - ohne Transportschäden" },
    { file: "lm-badge-rueckgabe.jpg?v=1785940537",
      alt: "14 Tage Rückgaberecht - einfach & unkompliziert" },
    { file: "lm-badge-finanzierung.jpg?v=1785940537",
      alt: "0 % Finanzierung mit PayPal - 3 bis 24 Monate" },
    { file: "lm-badge-ratenzahlung.jpg?v=1785940538",
      alt: "Flexible Ratenzahlung mit Klarna" }
  ];

  function badgeImg(b, sizes) {
    var url = BADGE_BASE + b.file;
    var srcset = [160, 240, 320].map(function (w) {
      return url + "&width=" + w + " " + w + "w";
    }).join(", ");
    return (
      '<li class="lm-badges__item">' +
      '<img class="lm-badges__img" src="' + url + '&width=240" srcset="' + srcset +
      '" sizes="' + sizes + '" width="400" height="400" loading="lazy" ' +
      'decoding="async" alt="' + b.alt + '">' +
      "</li>"
    );
  }

  function buildBadges(variant, sizes) {
    var el = document.createElement("div");
    el.className = "lm-badges lm-badges--" + variant;
    el.innerHTML =
      '<ul class="lm-badges__list">' +
      LM_BADGES.map(function (b) { return badgeImg(b, sizes); }).join("") +
      "</ul>";
    return el;
  }

  // Urun sayfasinda rozetlerin hangi ogenin ALTINA girecegini secer.
  function findBadgeAnchor() {
    var card = $(".lm-mp");
    if (card && isVisible(card) && !inHiddenHost(card)) {
      return (card.closest && card.closest(".product__block")) || card;
    }
    return findProductAnchor();
  }

  function mountBadges() {
    // Anasayfa - hero bolumunun hemen altinda
    if (CFG.page === "index") {
      var home = $(".lm-badges--home");
      if (!(home && isVisible(home))) {
        var main = $("#MainContent") || $("main");
        if (main) {
          var first = main.querySelector(".shopify-section");
          var strip = buildBadges("home", "(min-width: 750px) 152px, 40vw");
          if (home && home.parentNode) home.parentNode.removeChild(home);
          if (first) first.insertAdjacentElement("afterend", strip);
          else main.insertAdjacentElement("afterbegin", strip);
        }
      }
    }

    // Urun sayfasi - pazar yeri kartinin altinda
    if (CFG.page === "product") {
      var ex = $(".lm-badges--product");
      if (ex && isVisible(ex)) return;
      var anchor = findBadgeAnchor();
      if (!anchor) return; // gorunur hedef yok: gizli kaba yerlestirme
      if (ex && ex.parentNode) ex.parentNode.removeChild(ex);
      anchor.insertAdjacentElement(
        "afterend",
        buildBadges("product", "(min-width: 750px) 100px, 40vw")
      );
    }
  }
  run("lm-badges", mountBadges);

  /* ============================================================
     MADDE 2 - Urun sayfasinda yildizli yorum rozeti
     ============================================================ */
  run("judgeme-badge", function () {
    if (CFG.page !== "product" || !CFG.product) return;
    if ($(".jdgm-preview-badge")) return;
    var title = $(".product__title");
    if (!title) return;

    var badge = document.createElement("div");
    badge.className = "jdgm-widget jdgm-preview-badge lm-jdgm-badge";
    badge.setAttribute("data-id", String(CFG.product.id));
    badge.setAttribute("data-template", "product");
    title.insertAdjacentElement("afterend", badge);

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var j = window.jdgm;
      if (j) {
        try {
          if (typeof j.batchRenderBadges === "function") j.batchRenderBadges();
          else if (typeof j.customizeBadges === "function") j.customizeBadges();
        } catch (e) {}
        clearInterval(timer);
      } else if (tries > 30) {
        clearInterval(timer);
      }
    }, 400);
  });

  /* ============================================================
     MADDE 12 - Aciliyet unsuru (GERCEK stoktan)
     ------------------------------------------------------------
     Sadece Shopify'da stok takibi acik, stok bitince satis
     kapanan ("deny") ve kalan adedi esigin altinda olan
     varyantlarda gosterilir. Uydurma sayi uretilmez.
     DIKKAT: su an katalogda stok takibi kapali oldugu icin
     bu rozet gorunmez; takip acilinca kendiliginden devreye girer.
     ============================================================ */
  run("stock-urgency", function () {
    if (CFG.page !== "product" || !CFG.product) return;
    var variants = CFG.product.variants || [];
    if (!variants.length) return;
    var THRESHOLD = 5;

    function currentId() {
      var m = /[?&]variant=(\d+)/.exec(window.location.search);
      if (m) return parseInt(m[1], 10);
      var input = $('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return parseInt(input.value, 10);
      return variants[0].id;
    }

    function render() {
      var id = currentId();
      var v = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) { v = variants[i]; break; }
      }
      var show = v && v.management && v.policy === "deny" && v.qty > 0 && v.qty <= THRESHOLD;
      var el = $(".lm-stock");
      if (!show) { if (el) el.parentNode.removeChild(el); return; }
      if (!el) {
        var anchor = findProductAnchor();
        if (!anchor) return;
        el = document.createElement("p");
        el.className = "lm-stock";
        anchor.insertAdjacentElement("beforebegin", el);
      }
      el.innerHTML =
        '<span class="lm-stock__dot" aria-hidden="true"></span>Nur noch <strong>' +
        v.qty + "</strong> auf Lager";
    }

    render();
    setInterval(render, 1000);
  });

  /* Sayfa parcalari yeniden render edildiginde (varyant degisimi,
     sepet guncellemesi) eklentileri geri koy. Ilk saniyelerde DOM
     henuz hazir olmayabilecegi icin bu dongu ayni zamanda ilk
     yerlestirmeyi de garanti eder.
     28.08.2026: market-remount satiri kaldirildi. */
  var remountTicks = 0;
  var remountTimer = setInterval(function () {
    remountTicks++;
    run("trust-remount", mountTrust);
    run("badges-remount", mountBadges);
    if (remountTicks > 400) clearInterval(remountTimer); // ~10 dk sonra dur
  }, 1500);
})();
